import pic1 from "../Kadernath/images/4b0e26407342cd8ca079b1ee2900093a.jpg";
import pic2 from "../Kadernath/images/desktop1.jpg";
import pic3 from "../Kadernath/images/desktop2.jpg";
import pic4 from "../Kadernath/images/desktop3.jpg";
import pic5 from "../Kadernath/images/desktop4.jpg";
import pic6 from "../Kadernath/images/desktop5.jpg";
import pic7 from "../Kadernath/images/desktop6.jpg";
import pic8 from "../Kadernath/images/desktop7.jpg";
export const img = [
  {
    id: 1,
    img1: pic1,
  },
  {
    id: 2,
    img1: pic2,
  },
  {
    id: 3,
    img1: pic3,
  },
  {
    id: 4,
    img1: pic4,
  },
  {
    id: 5,
    img1: pic5,
  },
  {
    id: 6,
    img1: pic6,
  },
  {
    id: 7,
    img1: pic7,
  },
  {
    id: 8,
    img1: pic8,
  },
];
